import { render, staticRenderFns } from "./eprojectDeclear.vue?vue&type=template&id=66d0e979&scoped=true"
import script from "./eprojectDeclear.vue?vue&type=script&lang=js"
export * from "./eprojectDeclear.vue?vue&type=script&lang=js"
import style0 from "./eprojectDeclear.vue?vue&type=style&index=0&id=66d0e979&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0e979",
  null
  
)

export default component.exports